import { postRequest } from "../services/ApiService";
import Validators from "./Validators";

export const sendEmail = async (
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  message: string
) => {
  const adminEmail = "manar.ali.albadre@gmail.com";
  const url =
    "https://europe-west1-babylon-restaurant.cloudfunctions.net/contact_us_email";
  const messageBody = `the user: ${firstName} ${lastName} \n his phone: ${phone} \n and email: ${email} \n sent: ${message}`;
  if (!Validators.validateName(firstName)) {
    throw new Error("invalid first name");
  } else if (!Validators.validateName(lastName)) {
    throw new Error("invalid last name");
  } else if (phone?.length && !Validators.validatePhone(phone)) {
    throw new Error("invalid phone number");
  } else if (!Validators.validateEmail(email)) {
    throw new Error("invalid email");
  } else if (message?.length < 15) {
    throw new Error("too short message");
  } else if (message?.length > 1000) {
    throw new Error("too long message");
  }
  return postRequest(url, {
    to: adminEmail,
    subject: "website contact us",
    message: messageBody,
  });
};
